import React from "react";
import { connect } from "react-redux";

import { componentMounted, componentDismounted } from "./MountConnected.actions";

const MountConnected = (componentNamespace) => (Component) => {
  return class extends React.Component {
    componentDidMount() {
      this.props.onComponentMount(componentNamespace);
    }
    componentWillUnmount() {
      this.props.onComponentDismount(componentNamespace);
    }
    render() {
      return <Component {...this.props} />;
    }
  };
};

const mapDispatchToProps = (dispatch) => ({
  onComponentMount: (componentNamespace) =>
    dispatch(componentMounted({ componentNamespace })),
  onComponentDismount: (componentNamespace) =>
    dispatch(componentDismounted({ componentNamespace })),
});

const mountConnected = (componentNamespace) => (Component) =>
  connect(null, mapDispatchToProps)(MountConnected(componentNamespace)(Component));

export default mountConnected;
